import moment from 'moment';
import store from '@/store';
import { WHATSAPP_TELEMEDICINE_LINK } from '@/data/message-templates';

function dateToCalendar(date) {
  return moment(date)
    .calendar(null, {
      nextWeek: 'dddd, DD/MM [às] HH:mm',
      sameElse: 'DD/MM/YYYY [às] HH:mm',
    })
    .toLowerCase()
    .replace('-feira', '')
    .replace(' às 00:00', '');
}

export function whatsappText({
  patientName, professionalName, date, meetingUrl,
}) {
  const { branch } = store.state.user;

  return WHATSAPP_TELEMEDICINE_LINK
    .replace('[patient_name]', patientName ? patientName.split(' ')[0] : '')
    .replace('[professional_name]', professionalName || '')
    .replace('[date_hour]', dateToCalendar(date))
    .replace('[telemedicine_link]', meetingUrl)
    .replace('[facility_name]', branch.name);
}

export function isMetaEnabled() {
  const { branch } = store.state.user;
  return !!branch?.settings?.whatsapp?.enabled;
}

export function isWhatsappWebEnabled() {
  const { branch } = store.state.user;
  return !!branch?.settings?.whatsappWeb?.enabled;
}

export default whatsappText;
